import { useRef } from "react";
import { Bold } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

export const BoldTextarea = ({ value, onChange, testId, ...props }) => {
  const ref = useRef();
  const bold = () => {
    const el = ref.current;
    const v = value || "";
    const [a, b] = [el.selectionStart, el.selectionEnd];
    const sel = v.slice(a, b) || "teks tebal";
    const next = `${v.slice(0, a)}**${sel}**${v.slice(b)}`;
    onChange(next);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(a + 2, a + 2 + sel.length); });
  };
  return (
    <div className="overflow-hidden rounded-md border border-input bg-white focus-within:ring-1 focus-within:ring-ring">
      <div className="flex items-center gap-2 border-b border-slate-100 bg-slate-50 px-2 py-1">
        <button type="button" onClick={bold} title="Tebal (Ctrl+B)" className="flex h-7 w-7 items-center justify-center rounded hover:bg-white" data-testid={`${testId}-bold-btn`}><Bold className="h-4 w-4" /></button>
        <span className="text-[11px] text-slate-400">Blok teks lalu klik <b>B</b> / Ctrl+B → tampil <b>tebal</b> di PDF (ditulis **teks**)</span>
      </div>
      <Textarea ref={ref} {...props} className={`rounded-none border-0 shadow-none focus-visible:ring-0 ${props.className || ""}`} value={value || ""} onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "b") { e.preventDefault(); bold(); } }} data-testid={testId} />
    </div>
  );
};
